__turbopack_context__.v({
  "CollapsibleContent": "Collapsible-module__99aB3q__CollapsibleContent",
  "slideDown": "Collapsible-module__99aB3q__slideDown",
  "slideUp": "Collapsible-module__99aB3q__slideUp",
});
